import Axios from "axios";
import { IRsvpV2 } from "../views/GeneratorEdit/views/ViewRsvp/ViewRsvp";

export const getRsvps = async (siteId: string): Promise<IRsvpV2[]> => {
    const response = await Axios.get(process.env.REACT_APP_API_URL + "/api/rsvps/" + siteId + "/v4");
    const rsvps = response.data.data;
    return rsvps;
};